module.exports = "/assets/site/images/foldgazkereskedo.png?d7bcbb9790601ff4abc6afb1056f8c2c";